<template>
  <div>
    <el-form ref="formData" :model="formData" size="mini">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_packingType') || '装箱方式'"
          >
            <el-input v-model="formData.v_packingType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('INDEX.order_packing_materialNo') || '物料编号'"
          >
            <el-input v-model="formData.materialNo" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_packing_outBillType') || '出单类型'"
          >
            <el-input v-model="formData.v_outBillType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialName') || '物料名称'"
          >
            <el-input v-model="formData.materialName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialNameEn') || '英文名称'"
          >
            <el-input
              v-model="formData.materialDisplayName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialSize') || '包装尺寸'"
          >
            <el-input v-model="formData.materialSpec" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_boxWeight') || '包装箱重量'"
          >
            <el-input v-model="formData.boxWeight" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_boxVolume') || '包装箱体积'"
          >
            <el-input v-model="formData.boxVolume" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="
              this.$l('INDEX.order_package_orderPackingDesc') || '装箱方案描述'
            "
          >
            <el-input
              v-model="formData.orderPackingDesc"
              type="textarea"
              :placeholder="
                this.$l('INDEX.tips_order_packing_orderPackingDesc') ||
                  '请输入装箱方案描述'
              "
              :autosize="{ minRows: 4, maxRows: 6 }"
              :maxlength="250"
              show-word-limit
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>
      <GoodsTable class="mt-2" :orderPackingCode="orderPackingCode" />
    </el-form>
  </div>
</template>

<script>
import GoodsTable from '../goods-table'
export default {
  components: { GoodsTable },
  props: { orderPackingCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderPackingCode) return
      this.$api
        .pendingOrderDemandPackingDetailApi({
          orderPackingCode: this.orderPackingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
